import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;
import BadRoutePageViewImpl from './bad-route-page-view.js';

/**
 * View that layouts the bad route page.
 *
 * @class BadRoutePageView
 * @memberof Mojito.Applications.Sports.Pages.BadRoutePage
 */

/**
 * BadRoutePageView prop types.
 *
 * @memberof Mojito.Applications.Sports.Pages.BadRoutePage.BadRoutePageView
 */

export default UIView('BadRoutePageView', BadRoutePageViewImpl);
